import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorCrossCurrencyData } from '@/store/forwardAccumulator/selectors.ts';
import { forwardAccumulatorSlice } from '@/store/forwardAccumulator/slice.ts';
import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';

const CrossCurrency = () => {
  const dispatch = useAppDispatch();
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { crossCurrenciesList, crossCurrency, isCrossed } = useAppSelector((state) =>
    selectForwardAccumulatorCrossCurrencyData(state, tileId),
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleCrossCurrencySwitch = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Cross currency changed', event.target.value);
    return check({
      crossCurrency: event.target.value,
    });
  };

  const handleIsCrossed = (value: boolean) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Cross currency switched', value ? 'enabled' : 'disabled');
    return check({
      isCrossed: value,
    }).then(() => {
      if (!value) {
        dispatch(forwardAccumulatorSlice.actions.forwardAccumulatorCrossCurrencyUpdated({ tileId, crossCurrency: '' }));
      }
    });
  };

  return (
    <FormField formattedMessageId="forwardAccumulator.form.crossCurrency">
      <div className="d-flex gap-2 align-items-center">
        <div className="form-check form-check-sm ps-1">
          <input
            id="isCrossed"
            className="form-check-input me-8px"
            type="checkbox"
            checked={isCrossed}
            onChange={(e) => handleIsCrossed(e.target.checked)}
            data-e2e="isCrossed-checkbox"
          />
        </div>
        <div />
        {isCrossed && (
          <Form.Select
            value={crossCurrency}
            onChange={handleCrossCurrencySwitch}
            size="sm"
            data-e2e="cross-currency-selector"
          >
            {crossCurrenciesList?.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </Form.Select>
        )}
      </div>
    </FormField>
  );
};

export default CrossCurrency;
